module.exports = __webpack_public_path__ + "01_face.c852ffd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer1/01_face.png
// module id = 0sjT
// module chunks = 0